import {
  RECEIVED_RECOMMENDATIONS_DATA,
  RECEIVED_RECOMMENDATIONS_DATA_ERROR,
  SET_PLAYLIST,
} from './recommendedVideos.actions'

const initialRecommendedItems = Array.from({ length: 5 }, (v, i) => i).map(item => {
  return {
    id: 0,
    title: '',
    description: '',
    image: '',
    hlink: '#',
  }
})

const INITIAL_STATE = {
  isInitialized: false,
  recievedError: false,
  recommendedItems: initialRecommendedItems,
  playlistId: null,
}

function setState(state, newState) {
  return { ...state, ...newState }
}

export function recommendedListReducers(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RECEIVED_RECOMMENDATIONS_DATA:
      return setState(state, action.payload)
    case RECEIVED_RECOMMENDATIONS_DATA_ERROR:
      return setState(state, action.payload)
    case SET_PLAYLIST:
      return setState(state, { playlistId: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/recommendedVideos/recommendedVideos.reducers.js